import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'
import type {
  ToastInput,
  PanelInput,
  AlertInput,
  AlertOptions,
  ConfirmInput,
  ConfirmOptions,
  PromptInput,
  PromptOptions,
} from '../types/index.js'

export class UIModule {
  constructor(private rpc: RpcEngine) {}

  toast(options: ToastInput):                            Promise<void>   { return this.rpc.post(METHODS.UI_TOAST, [options]) }
  alert(options: AlertOptions):                          Promise<void>
  alert(message: string):                                Promise<void>
  alert(messageOrOptions: AlertInput):                   Promise<void>   { return this.rpc.call(METHODS.UI_ALERT, [messageOrOptions]) }
  confirm(options: ConfirmOptions):                      Promise<boolean>
  confirm(message: string):                              Promise<boolean>
  confirm(messageOrOptions: ConfirmInput):               Promise<boolean>{ return this.rpc.call(METHODS.UI_CONFIRM, [messageOrOptions]) }
  prompt(options: PromptOptions):                        Promise<string | null>
  prompt(message: string, defaultValue?: string):        Promise<string | null>
  prompt(messageOrOptions: PromptInput, defaultValue?: string): Promise<string | null> {
    if (typeof messageOrOptions === 'object' && messageOrOptions !== null) {
      return this.rpc.call(METHODS.UI_PROMPT, [messageOrOptions])
    }
    return this.rpc.call(METHODS.UI_PROMPT, [messageOrOptions, defaultValue])
  }
  openPanel(options: PanelInput):                        Promise<void>   { return this.rpc.call(METHODS.UI_PANEL_OPEN, [options]) }
  closePanel():                                          Promise<void>   { return this.rpc.call(METHODS.UI_PANEL_CLOSE) }
  hideChatInput():                                       Promise<void>   { return this.rpc.post(METHODS.UI_CHAT_INPUT_HIDE) }
  showChatInput():                                       Promise<void>   { return this.rpc.post(METHODS.UI_CHAT_INPUT_SHOW) }
  setTheme(theme: 'dark' | 'light' | 'system'):          Promise<void>   { return this.rpc.post(METHODS.UI_THEME_SET, [theme]) }
  scrollToBottom():                                      Promise<void>   { return this.rpc.post(METHODS.UI_SCROLL_TO_BOTTOM) }
}
